import { memo, useMemo } from "react";

import type { IDashboardSummaryProps } from "@components/molecules/dashboardSummary/types";
import { DashboardCard } from "@components/molecules/dashboardCard";
import { Subtitle } from "@components/atoms/subtitle";
import { BaseLoader } from "@components/molecules/baseLoader";
import { Swiper } from "@components/atoms/swiper";

export const DashboardSummary = memo(function DashboardSummary({
  items,
  title,
  isLoading,
  isError,
}: IDashboardSummaryProps) {
  const itemsComponent = useMemo(
    () => items?.map((item) => <DashboardCard card={item} key={item.key} />),
    [items],
  );

  return (
    <>
      <Subtitle title={title || "summary"} />
      <BaseLoader
        type={"dashboard-card"}
        isLoading={isLoading}
        isError={isError}
      >
        <Swiper>{itemsComponent}</Swiper>
      </BaseLoader>
    </>
  );
});
